import {startOfYear, tomorrowStartOfTheDay} from '../utils/time-utils';
import { StepKey } from '../../core/enums/step-key.enum';

const defaultMock = {
  'ocDetails': {
      'insurer': {
        'partyTypeCode': 'NATURAL_PERSON',
        'pesel': '92011307591',
        'lastName': 'Doe',
        'firstName': 'John',
        'birthDate': '1992-01-13T00:00:00.000Z',
        'nip': null,
        'companyName': null,
        'address': {
          'postalCode': '22-610'
        }
      },
      'owner': {
        'partyTypeCode': 'NATURAL_PERSON',
        'address': {
          'postalCode': '22-610'
        },
        'coOwners': 0,
        'firstName': 'John',
        'lastName': 'Doe',
        'pesel': '92070649951',
        'birthDate': '1992-12-14T00:00:00.000Z',
        'drivingLicenseIssueYear': startOfYear(2013),
        'drivingLicenseIssueMonth': 1,
        'nip': null,
        'companyName': null,
        'matrimonialStatus': 'SINGLE',
        'childrenUnder26': false,
      },
      'contact': {
        'email': 'komunikacja.o4b@gmail.com',
        'phoneNumber': '48456576688',
        'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
      },
      'vehicle': {
        'registrationNumber': 'LTM32022',
        'brandCode': '412',
        'productionYear': '2009-12-31T23:00:00.000Z',
        'modelCode': '13717',
        'fuelTypeCode': '00100001',
        'engineCapacity': 1984,
        'vehicleCodeEurotax': '75761',
        'vehicleCodeInfoekspert': '100061',
        'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
        'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
        'isLeasing': 'LEASING_NO',
        'isGasInstallation': 'GAS_INSTALLATION_YES',
        'isAbroad': 'TO_1',
        'startInsuranceDate': tomorrowStartOfTheDay(),
        'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
        'avgMileagePerYear': 'FROM_15001_TO_20000',
        'actualMileage': '260 000',
        'usageType': 'PRIVATE',
        'vehicleCondition': 'NOT_DAMAGED',
        'parkingPlace': 'STREET',
        'abroadImported': 'ABROAD_IMPORTED_NO',
        'purchaseYear': '2009-12-31T23:00:00.000Z',
      }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const missingRegistrationNumberData = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '92011307591',
      'lastName': 'Doe',
      'firstName': 'John',
      'birthDate': '1992-01-13T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'firstName': 'John',
      'lastName': 'Doe',
      'pesel': '92121441994',
      'birthDate': '1992-12-14T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const partialData = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const tesla2013 = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '82091191894',
      'lastName': 'Taki',
      'firstName': 'Marcin',
      'birthDate': '1982-09-11T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-640'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-640'
      },
      'coOwners': 0,
      'pesel': '82091191894',
      'lastName': 'Taki',
      'firstName': 'Marcin',
      'birthDate': '1982-09-11T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2009),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48666777888',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2013-01-01T00:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '15 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LUXXX',
      'brandCode': '343',
      'productionYear': '2012-12-31T23:00:00.000Z',
      'modelCode': '16968',
      'fuelTypeCode': '00100004',
      'engineCapacity': 0,
      'vehicleCodeEurotax': '123026',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2012-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'CARD'
    }
  }
};

const audi2019 = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '65042724673',
      'lastName': 'Maniak',
      'firstName': 'Mateusz',
      'birthDate': '1965-04-27T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'pesel': '65042724673',
      'lastName': 'Maniak',
      'firstName': 'Mateusz',
      'birthDate': '1965-04-27T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2008),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2019-01-01T00:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '20 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'SHARED_GARAGE',
      'registrationNumber': 'LU66000',
      'brandCode': '354',
      'productionYear': '2018-12-31T23:00:00.000Z',
      'modelCode': '16813',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '137189',
      'vehicleCodeInfoekspert': '183048',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2018-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const ford1993 = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '79100898192',
      'lastName': 'Marecki',
      'firstName': 'Marek',
      'birthDate': '1979-10-08T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'pesel': '79100898192',
      'lastName': 'Marecki',
      'firstName': 'Marek',
      'birthDate': '1979-10-08T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2001),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '1993-01-01T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '350 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LU00002',
      'brandCode': '369',
      'productionYear': '1992-12-31T23:00:00.000Z',
      'modelCode': '7703',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1597,
      'vehicleCodeEurotax': '1431',
      'vehicleCodeInfoekspert': '18238',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '1992-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const mercedes2015diesel = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '62070534942',
      'lastName': 'Burko',
      'firstName': 'Justyna',
      'birthDate': '1962-07-05T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-100'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-100'
      },
      'coOwners': 0,
      'pesel': '62070534942',
      'lastName': 'Burko',
      'firstName': 'Justyna',
      'birthDate': '1962-07-05T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2001),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_NO',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'NONE',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2005-01-01T00:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '650 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LU00003',
      'brandCode': '387',
      'productionYear': '2004-12-31T23:00:00.000Z',
      'modelCode': '11643',
      'fuelTypeCode': '00100003',
      'engineCapacity': 2685,
      'vehicleCodeEurotax': '51169',
      'vehicleCodeInfoekspert': '71208',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2004-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'CARD'
    }
  }
};

export const damageFord1993 = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '79100898192',
      'lastName': 'Marecki',
      'firstName': 'Marek',
      'birthDate': '1979-10-08T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'pesel': '79100898192',
      'lastName': 'Marecki',
      'firstName': 'Marek',
      'birthDate': '1979-10-08T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2001),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '1993-01-01T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '350 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'DAMAGED',
      'damageDescription': 'pęknięty tylko zderzak',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LU00002',
      'brandCode': '369',
      'productionYear': '1992-12-31T23:00:00.000Z',
      'modelCode': '7703',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1597,
      'vehicleCodeEurotax': '1431',
      'vehicleCodeInfoekspert': '18238',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '1992-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const paymentStandarDefaultMock = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '92011307591',
      'lastName': 'Doe',
      'firstName': 'John',
      'birthDate': '1992-01-13T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'firstName': 'John',
      'lastName': 'Doe',
      'pesel': '92121441994',
      'birthDate': '1992-12-14T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'vehicleModel': {
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_NO',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'NONE',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LTM32031',
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '2FTEF15H4TCA85639',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'insurer': {
      'address': {
        'city': 'Lublin',
        'street': 'Zwyczajna',
        'buildingNumber': '12',
        'flatNumber': '13'
      }
    },
    'paymentMethod': {
      'paymentMethod': 'STANDARD_TRANSFER'
    }
  }
};

const oneCoOwner = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '92011307591',
      'lastName': 'Kowalski',
      'firstName': 'Jan',
      'birthDate': '1992-01-13T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 1,
      'coOwnersData': [
        {
          'partyTypeCode': 'NATURAL_PERSON',
          'address': {
            'postalCode': '22-100'
          },
          'nip': null,
          'companyName': null,
          'firstName': 'Marcin',
          'lastName': 'Nowak',
          'pesel': '65102157412',
          'drivingLicenseIssueYear': startOfYear(1993),
          'drivingLicenseIssueMonth': 1,
          'birthDate': '1965-10-21T00:00:00.000Z'
        }
      ],
      'firstName': 'Jan',
      'lastName': 'Kowalski',
      'pesel': '92121441994',
      'birthDate': '1992-12-14T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LTM32031',
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const twoCoOwners = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '92011307591',
      'lastName': 'Kowalski',
      'firstName': 'Jan',
      'birthDate': '1992-01-13T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 2,
      'coOwnersData': [
        {
          'partyTypeCode': 'NATURAL_PERSON',
          'address': {
            'postalCode': '22-335'
          },
          'nip': null,
          'companyName': null,
          'firstName': 'Marcin',
          'lastName': 'Nowak',
          'pesel': '65102157412',
          'drivingLicenseIssueYear': startOfYear(1993),
          'drivingLicenseIssueMonth': 1,
          'birthDate': '1965-10-21T00:00:00.000Z'
        },
        {
          'partyTypeCode': 'NATURAL_PERSON',
          'address': {
            'postalCode': '22-300'
          },
          'nip': null,
          'companyName': null,
          'firstName': 'Grzegorz',
          'lastName': 'Bielski',
          'pesel': '89050344632',
          'drivingLicenseIssueYear': startOfYear(2012),
          'drivingLicenseIssueMonth': 1,
          'birthDate': '1989-05-03T00:00:00.000Z'
        }
      ],
      'firstName': 'Jan',
      'lastName': 'Kowalski',
      'pesel': '92121441994',
      'birthDate': '1992-12-14T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LTM00007',
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const businessActivityDefaultMock = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'BUSINESS_ACTIVITY',
      'pesel': '92121441994',
      'lastName': 'Kowalski',
      'firstName': 'Jan',
      'companyName': 'Kowalski Company',
      'nip': '5239210716',
      'address': {
        'postalCode': '22-100'
      },
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
    },
    'owner': {
      'partyTypeCode': 'BUSINESS_ACTIVITY',
      'address': {
        'postalCode': '22-100'
      },
      'nip': '523-921-07-16',
      'pesel': '92121441994',
      'companyName': 'Kowalski Company',
      'coOwners': 0,
      'birthDate': null,
      'drivingLicenseIssueYear': startOfYear(2013),
      'drivingLicenseIssueMonth': 1,
      'firstName': 'Jan',
      'lastName': 'Kowalski',
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2009-12-31T23:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '260 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'STREET',
      'registrationNumber': 'LTM32031',
      'brandCode': '412',
      'productionYear': '2009-12-31T23:00:00.000Z',
      'modelCode': '13717',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1984,
      'vehicleCodeEurotax': '75761',
      'vehicleCodeInfoekspert': '100061',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2009-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};

const audi2018ACASO = {
  'ocDetails': {
    'insurer': {
      'partyTypeCode': 'NATURAL_PERSON',
      'pesel': '65042724673',
      'lastName': 'Maniak',
      'firstName': 'Mateusz',
      'birthDate': '1965-04-27T00:00:00.000Z',
      'nip': null,
      'companyName': null,
      'address': {
        'postalCode': '22-610'
      }
    },
    'owner': {
      'partyTypeCode': 'NATURAL_PERSON',
      'address': {
        'postalCode': '22-610'
      },
      'coOwners': 0,
      'pesel': '65042724673',
      'lastName': 'Maniak',
      'firstName': 'Mateusz',
      'birthDate': '1965-04-27T00:00:00.000Z',
      'drivingLicenseIssueYear': startOfYear(2008),
      'drivingLicenseIssueMonth': 1,
      'nip': null,
      'companyName': null,
      'matrimonialStatus': 'SINGLE',
      'childrenUnder26': false,
    },
    'contact': {
      'email': 'komunikacja.o4b@gmail.com',
      'phoneNumber': '48456576688',
      'CALCULATION_REGULATIONS_PRIVACY_POLICY_AGREEMENT': true // agreement code
    },
    'vehicle': {
      'isValidCarInspection': 'VALID_CAR_INSPECTION_YES',
      'isLeftHandDrive': 'LEFT_HAND_DRIVE_YES',
      'isLeasing': 'LEASING_NO',
      'isGasInstallation': 'GAS_INSTALLATION_YES',
      'isAbroad': 'TO_1',
      'startInsuranceDate': tomorrowStartOfTheDay(),
      'firstRegistrationDate': '2019-01-01T00:00:00.000Z',
      'avgMileagePerYear': 'FROM_15001_TO_20000',
      'actualMileage': '20 000',
      'usageType': 'PRIVATE',
      'vehicleCondition': 'NOT_DAMAGED',
      'parkingPlace': 'SHARED_GARAGE',
      'registrationNumber': 'LU66000',
      'brandCode': '354',
      'productionYear': '2017-12-31T23:00:00.000Z',
      'modelCode': '16421',
      'fuelTypeCode': '00100001',
      'engineCapacity': 1395,
      'vehicleCodeEurotax': '109804',
      'vehicleCodeInfoekspert': '149881',
      'abroadImported': 'ABROAD_IMPORTED_NO',
      'purchaseYear': '2017-12-31T23:00:00.000Z',
    }
  },
  [StepKey.THIRD_STEP]: {
    'vehicle': {
      'vin': '1HGCM82633A004352',
      'keysAmount': 'ONE',
      'immobilizer': 'IMMOBILIZER_YES',
      'mechanicLockTransmission': 'MECHANIC_LOCK_TRANSMISSION_YES',
      'autoalarm': 'AUTOALARM_YES',
      'gps': 'GPS_YES',
    },
    'agreements': {
      'OWU_2016_AGREEMENT': true,
      'MOTO_RENEWAL_AGREEMENT_WWW': true,
      'ALL_MOTO_INSURED_OWU_DELIVERED': true,
      'REGULATION_AGREEMENT_WWW': true,
    },
    'paymentMethod': {
      'paymentMethod': 'BLIK'
    }
  }
};


export const formsDataMock = [
  {
    key: 'Passat CC - benzyna',
    value: defaultMock
  },
  {
    key: 'Audi 2018 - AC/ASO',
    value: audi2018ACASO
  },
  {
    key: 'Passat CC - brak nr rejestracyjnego',
    value: missingRegistrationNumberData
  },
  {
    key: 'Passat CC - dane częściowe',
    value: partialData
  },
  {
    key: 'Audi 2019 - benzyna',
    value: audi2019
  },
  {
    key: 'Ford 1993 - benzyna',
    value: ford1993
  },
  {
    key: 'Tesla 2013 - elektryczny',
    value: tesla2013
  },
  {
    key: 'Mercedes 2015 - diesel, bez przeglądu',
    value: mercedes2015diesel
  },
  {
    key: 'Passat CC - Przelew tradycyjny',
    value: paymentStandarDefaultMock
  },
  {
    key: 'Uszkodzony Ford 1993',
    value: damageFord1993
  },
  {
    key: 'Passat CC - jeden współwłaściciel',
    value: oneCoOwner
  },
  {
    key: 'Passat CC - dwóch współwłaścicieli',
    value: twoCoOwners
  },
  {
    key: 'Passat CC - działalność gospodarcza',
    value: businessActivityDefaultMock
  }
];
